/**
 * docs/ROADMAP.md B1 — the WeChat in-app browser (especially on iOS) has
 * unreliable `getUserMedia` support, and WeChat is the students' main entry
 * point. We detect it and tell them to open the link in Safari / Chrome.
 */
export function isWeChatBrowser(ua: string = navigator.userAgent): boolean {
  return /MicroMessenger/i.test(ua);
}

/**
 * Short, human label for a session's user agent ("iPhone · Safari"),
 * used by 我的设备 (ACCOUNTS.md §3). Deliberately coarse — it only has to
 * help someone recognise their own device.
 */
export function deviceLabel(ua: string | null | undefined): string {
  if (!ua) return "未知设备";
  const os = /iPhone/i.test(ua)
    ? "iPhone"
    : /iPad/i.test(ua)
      ? "iPad"
      : /Android/i.test(ua)
        ? "安卓手机"
        : /Mac OS X|Macintosh/i.test(ua)
          ? "Mac"
          : /Windows/i.test(ua)
            ? "Windows"
            : /Linux/i.test(ua)
              ? "Linux"
              : "其他系统";
  const browser = /MicroMessenger/i.test(ua)
    ? "微信"
    : /Edg\//i.test(ua)
      ? "Edge"
      : /Firefox/i.test(ua)
        ? "Firefox"
        : /Chrome|CriOS/i.test(ua)
          ? "Chrome"
          : /Safari/i.test(ua)
            ? "Safari"
            : "其他浏览器";
  return `${os} · ${browser}`;
}

/** Copy the current URL; returns false when the clipboard is unavailable. */
export async function copyCurrentUrl(): Promise<boolean> {
  const url = window.location.href;
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(url);
      return true;
    }
  } catch {
    /* fall through to the manual path */
  }
  return false;
}
